export * from "./editProfileRequest";
export * from "./userRoom";
export * from "./authorization";
export * from "./registration";
export * from "./courses";
export * from "./changePassword";
export * from "./testTemplateAndEvent";
export * from "./addCourseToUser";
// @ts-ignore
export * from "./questionAndAnswer";
export * from "./infoOfCourse";
